import CollectionApi from 'client/api/v2/CollectionApi';
import GeolocationType from 'client/Security/data/GeolocationType';

class GeolocationApi extends CollectionApi {
  constructor() {
    super('/api/v2/geolocation/countries', {
      skip: 0,
      limit: 300, // There are only ~250 countries. We want them all.
      sort: '',
    });
  }

  async fetch(...args) {
    const response = await super.fetch(...args);

    if (Array.isArray(response.results)) {
      response.results = response.results.map(result => GeolocationType.fromApi(result));
    }

    return response;
  }
}

export default new GeolocationApi();
